import { mix, rgba } from 'polished';

import { interpolateRecord } from '@/utils/theme/utils';

import {
  base,
  type BaseFgShades,
  type BaseGridShades,
  type bg as bgBase,
  type PaletteShape
} from './palette';

const pink = '#FDDDDD';
const black = '#222230';
const gridPink = '#EDABAB';

export const gridShades: BaseGridShades = {
  '200': 0.12,
  '300': 0.4,
  '400': 0.5,
  '500': 0.6,
  '600': 0.5,
  '700': 0.7,
  '1200': 1
};

export const fgShades: BaseFgShades = {
  '100': 0,
  '200': 0.03,
  '300': 0.05,
  '400': 0.07,
  '500': 0.09,
  '600': 0.11,
  '700': 0.14,
  '800': 0.22,
  '900': 0.44,
  '1000': 0.48,
  '1100': 0.57,
  '1200': 0.91
};

const fg = interpolateRecord(fgShades, 'fg', v => mix(v, black, pink));

const fgA = interpolateRecord(fgShades, 'fgA', v => rgba(black, v));

const grid = interpolateRecord(gridShades, 'grid', v => mix(v, gridPink, pink));
grid.grid1200 = black;

const bg: typeof bgBase = {
  bg300: gridPink,
  bg400: mix(0.4, gridPink, pink),
  bg500: pink
};

export const palette: PaletteShape = {
  ...base,
  ...fg,
  ...fgA,
  ...grid,
  ...bg,
  fgLoud: black
};
